import { Link } from 'react-router-dom';
import ArtworkIcon from "src/assets/all-icons/artwork-icon.jsx";

import ArtistIcon from '@/assets/all-icons/artist-icon';
import ArtlistIcon from '@/assets/all-icons/artlist-icon';
import GalleryIcon from '@/assets/all-icons/gallery-icon';
import useProtectActionUnregistered from '@/hooks/useProtectActionUnregistered';
import useTranslations from '@/i18n/useTranslations';
import UnregisteredPopup from "@/shared-components/popups/unregistered-user-popup";

import './styles/HomeLinks.css';

function HomeLink({ to, text, icon }) {
  const { privateActionHandlerUnregistered, showPopup } = useProtectActionUnregistered({ typeOfProtection: "USER_LIMIT_VIEW" });

  function handleClick(event) {
    privateActionHandlerUnregistered(event);
    if (event.defaultPrevented) {
      return;
    }
  }

  return (
    <>
      {showPopup && <UnregisteredPopup showPopUp={showPopup}/>}
      <Link onClick={handleClick} className="home-link__container no-underline" to={{
        pathname: to,
        state: { from: true }
      }}  >
        {icon}
        <span className="home-link__text">{text}</span>
      </Link>
    </>
  );
}

export default function HomeLinks() {
  const tSearchCategories = useTranslations('common.shared.search.categories');
  const tProfileTabs = useTranslations('common.profile.navigation.tabs');

  return (
    <>
      <div className="home-links__container element-non-selectable">
        <HomeLink to="/galleries" text={tSearchCategories('galleries')} icon={<GalleryIcon className="home-links__icon gallery" />} />
        <HomeLink to="/artists" text={tSearchCategories('artists')} icon={<ArtistIcon className="home-links__icon artist" />} />
        <HomeLink to="/artworks" text={tSearchCategories('artworks')} icon={<ArtworkIcon className="home-links__icon artwork" />} />
        <HomeLink to="/artlists" text={tProfileTabs('artlists')} icon={<ArtlistIcon className="home-links__icon artlist" />} />
      </div>
    </>
  );
}
